import utils from '../utils'
import { SEO_DEFAULT } from './defaultSeo'
import { parseSeoMetaField } from './parseSeoMeta'
import { seoState } from './seoState'

let requestId = 0

function normalizeSeoPath(raw) {
  let value = raw == null ? '' : String(raw).trim()
  if (!value) return ''

  let hash = ''
  const hashAt = value.indexOf('#')
  if (hashAt !== -1) {
    hash = value.slice(hashAt)
    if (hash === '#') hash = ''
    value = value.slice(0, hashAt)
  }

  const queryAt = value.indexOf('?')
  if (queryAt !== -1) value = value.slice(0, queryAt)

  if (/^https?:\/\//i.test(value)) {
    try {
      value = new URL(value).pathname || '/'
    } catch (e) {
      value = '/'
    }
  }

  if (!value || value[0] !== '/') value = `/${value}`
  value = value.replace(/\/+/g, '/')
  if (value.length > 1) value = value.replace(/\/+$/, '')

  return (value || '/') + hash
}

function routeSeoPath(route) {
  const path = normalizeSeoPath(route && route.path ? route.path : '/')
  const hash = route && route.hash && route.hash !== '#' ? route.hash : ''
  return path + hash
}

/** Побочные страницы раздела берут title, description и keywords у /about/products. */
function sectionSeoPath(route) {
  if (!route) return null
  if (route.name === 'aboutproductssmell' || route.name === 'aboutproductsoriginal') {
    return '/about/products'
  }
  return null
}

function canonicalUrl(path) {
  const origin = window.location.origin
  const normalized = normalizeSeoPath(path) || '/'
  const parts = normalized.split('#')
  const pathname = parts[0] || '/'
  const hash = parts[1] ? `#${parts[1]}` : ''
  if (pathname === '/') return `${origin}/${hash}`
  return `${origin}${pathname}${hash}`
}

function setMeta(attribute, key, content) {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, key)
    document.head.appendChild(element)
  }
  element.setAttribute('content', content)
}

function setCanonical(href) {
  let element = document.head.querySelector('link[rel="canonical"]')
  if (!element) {
    element = document.createElement('link')
    element.setAttribute('rel', 'canonical')
    document.head.appendChild(element)
  }
  element.setAttribute('href', href)
}

function applyDocumentHead(seo, canonical) {
  const parsed = parseSeoMetaField(seo && seo.meta)
  const description = parsed.description.trim()
  const keywords = seo && seo.request ? String(seo.request).trim() : ''
  const title = seo && seo.title ? String(seo.title).trim() : ''

  if (title) {
    document.title = title
    setMeta('property', 'og:title', title)
    setMeta('name', 'twitter:title', title)
  }
  if (description) {
    setMeta('name', 'description', description)
    setMeta('property', 'og:description', description)
    setMeta('name', 'twitter:description', description)
  }
  if (keywords) setMeta('name', 'keywords', keywords)
  setMeta('name', 'robots', 'index, follow')
  setMeta('property', 'og:url', canonical)
  setCanonical(canonical)

  if (parsed.appleMobileWebAppTitle) setMeta('name', 'apple-mobile-web-app-title', parsed.appleMobileWebAppTitle)
  if (parsed.applicationName) setMeta('name', 'application-name', parsed.applicationName)
  if (parsed.msapplicationTileColor) setMeta('name', 'msapplication-TileColor', parsed.msapplicationTileColor)
  if (parsed.themeColor) setMeta('name', 'theme-color', parsed.themeColor)
}

async function fetchSeoByPath(path) {
  try {
    const { apiBase, BRAND_ID: brandId } = utils()
    const url = new URL(`${String(apiBase()).replace(/\/+$/, '')}/seo/public`, window.location.origin)
    url.searchParams.set('brand_id', String(brandId))
    url.searchParams.set('path', path || '/')
    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
    })
    if (!response.ok) return null
    const data = await response.json()
    const id = Number(data && data.id)
    return Number.isFinite(id) && id > 0 ? data : null
  } catch (error) {
    console.warn('SEO: не удалось загрузить данные', error)
    return null
  }
}

export function paintCurrentSeoHead() {
  if (typeof window === 'undefined') return
  const path = `${window.location.pathname || '/'}${window.location.hash && window.location.hash !== '#' ? window.location.hash : ''}`
  applyDocumentHead(seoState.page, canonicalUrl(path))
}

/** type=default подставляет API, если для пути нет своей записи. H1 — только при совпадении link. */
export async function applyRouteSeo(route) {
  if (typeof window === 'undefined') return
  const id = ++requestId
  const path = routeSeoPath(route)
  const sectionPath = sectionSeoPath(route)
  seoState.page = null

  const seo = await fetchSeoByPath(sectionPath || path)
  if (id !== requestId) return

  if (sectionPath) {
    seoState.page = seo ? { ...seo, h1: '' } : { ...SEO_DEFAULT }
  } else {
    const matched = seo && normalizeSeoPath(seo.link) === path
    seoState.page = seo ? (matched ? seo : { ...seo, h1: '' }) : { ...SEO_DEFAULT }
  }
  applyDocumentHead(seoState.page, canonicalUrl(path))
}
